/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const jobStyles = {
  background: {
    backgroundColor: "background.contrast",
  },
  container: {
    paddingTop: "1rem",
    paddingBottom: "1rem",
  },
  list: {
    "& li": {
      paddingBottom: "1rem",
    },
  },
  sendApplicationBox: {
    fontSize: "1.5rem",
    color: "primary.main",
    border: "1px solid " + "primary.main",
    padding: "1rem",
    textAlign: "center",
  },
};

export default jobStyles;
